import {Col, Row, Space} from "antd";
import {useTranslation} from "react-i18next";
import {useGetHazardTypeClassesQuery} from "../../../../redux/api/hazardTypes";
import {useGetAssetBiodiversityDataSourcesQuery} from "../../../../redux/api/asset";
import {
  AssetsFiltersFE,
  AssetsOptionLabelValueFilters,
  AssetsSortersFE,
  isAssetsTableStaticColumn,
  StaticAssetsFilters
} from "../../../../types/internal/tables/assetsTable";
import {capitalize} from "lodash";
import {getTranslationAssetTableColumnKey} from "../../../../utils/translation";
import TableSorter from "../../../common/TableSorter";
import AssetsTableFilterCreationAreas from "./AssetsTableFilterCreationAreas";
import {useGetAlertParametersTypeQuery} from "../../../../redux/api/alertParameters";

interface AssetsTableColumnHeaderCreationAreasProps {
  columnKey: string,
  filters: AssetsFiltersFE,
  filtersInExcludeMode: AssetsOptionLabelValueFilters[],
  sorters: AssetsSortersFE,
  addFilters: (addFilters: AssetsFiltersFE) => void,
  removeFilters: (removeFilters: ((StaticAssetsFilters | 'hazards') | string)[] | ((StaticAssetsFilters | 'hazards') | string)) => void,
  setOverallLandCoverageNullFilter: (source: string ) => void,
  removeOverallLandCoverageFilter: (source: string) => void,
  setOverallLandCoverageMinFilter: (source: string, value: number) => void,
  removeOverallLandCoverageMinFilter: (source: string) => void,
  setOverallLandCoverageMaxFilter: (source: string, value: number) => void,
  removeOverallLandCoverageMaxFilter: (source: string) => void,
  insertFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
  removeFilterInExcludeMode: (filterInExcludeMode: AssetsOptionLabelValueFilters) => void,
  addSorters: (addSorters: AssetsSortersFE) => void,
  removeSorters: (removeSorters: keyof AssetsSortersFE | (keyof AssetsSortersFE)[]) => void,
}
export default function AssetsTableColumnHeaderCreationAreas({
  columnKey,
  filters,
  filtersInExcludeMode,
  sorters,
  addFilters,
  removeFilters,
  setOverallLandCoverageNullFilter,
  removeOverallLandCoverageFilter,
  setOverallLandCoverageMinFilter,
  removeOverallLandCoverageMinFilter,
  setOverallLandCoverageMaxFilter,
  removeOverallLandCoverageMaxFilter,
  insertFilterInExcludeMode,
  removeFilterInExcludeMode,
  addSorters,
  removeSorters,
}: AssetsTableColumnHeaderCreationAreasProps) {
  const {t} = useTranslation();

  let filter = <></>;
  let sorter = <></>;
  let title = '';

  const {
    data: hazardTypes,
  } = useGetHazardTypeClassesQuery();
  const {
    data: biodiversitySources,
  } = useGetAssetBiodiversityDataSourcesQuery();
  const {
    data: alertParametersTypeSources
  } = useGetAlertParametersTypeQuery({paginate: false})

  const bioSource = biodiversitySources?.find(bs => bs.value === columnKey)?.label;
  const hazard = hazardTypes?.find(ht => ht.code === columnKey)?.name;
  const alertParameter = alertParametersTypeSources?.find(param => param.code === columnKey)?.label

  if (isAssetsTableStaticColumn(columnKey)) {
    title = capitalize(t(getTranslationAssetTableColumnKey(columnKey)));
  } else {
    if (bioSource) {
      title = `${capitalize(t("assets.landCoveragePercentage"))} ${bioSource}`;
    }
    if (hazard) {
      title = capitalize(hazard);
    }
    if (alertParameter) {
      title = capitalize(alertParameter)
    }
  }

  switch (columnKey) {
    default:
      if (bioSource) {
        sorter = <TableSorter
          onChange={(type) => {
            if (type) {
              addSorters({[`overall_land_coverage_${columnKey}`]: type || undefined});
            } else {
              removeSorters(`overall_land_coverage_${columnKey}`);
            }
          }}
          value={sorters[`overall_land_coverage_${columnKey}`] || null}
        />;
      } else {
        sorter = <TableSorter
          onChange={(type) => {
            if (type) {
              addSorters({[columnKey]: type || undefined});
            } else {
              removeSorters(columnKey);
            }
          }}
          value={sorters[columnKey] || null}
        />;
      }

      filter = <AssetsTableFilterCreationAreas
        columnKey={columnKey}
        filters={filters}
        filtersInExcludeMode={filtersInExcludeMode}
        addFilters={addFilters}
        removeFilters={removeFilters}
        setOverallLandCoverageNullFilter={setOverallLandCoverageNullFilter}
        removeOverallLandCoverageFilter={removeOverallLandCoverageFilter}
        setOverallLandCoverageMinFilter={setOverallLandCoverageMinFilter}
        removeOverallLandCoverageMinFilter={removeOverallLandCoverageMinFilter}
        setOverallLandCoverageMaxFilter={setOverallLandCoverageMaxFilter}
        removeOverallLandCoverageMaxFilter={removeOverallLandCoverageMaxFilter}
        insertFilterInExcludeMode={insertFilterInExcludeMode}
        removeFilterInExcludeMode={removeFilterInExcludeMode}
      />;
      break;
  }

  return (
    <Row align={'middle'} wrap={false}>
      <Col flex={1} style={{marginRight: '0.5rem'}}>
        {title}
      </Col>
      <Col>
        <Space>
          {sorter}
          {filter}
        </Space>
      </Col>
    </Row>
  );
}